var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsNewsmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47 10.41c.07.41-.25.78-.68.78a.67.67 0 0 1-.66-.53l-.69-3.04h-.3a.16.16 0 0 1-.16-.16v-4.7c0-.08.07-.15.16-.15h2.1c.08 0 .16.07.16.16v4.7c0 .1-.08.17-.16.17H5l.47 2.77Zm5.2-8.98A9.85 9.85 0 0 1 5.8 2.95v4.33c1.61.15 3.3.45 4.89 1.51.33.24.65.08.65-.4V1.84c0-.46-.32-.64-.65-.4Zm-10 3.68c0 1.16.83 2.12 1.93 2.32V2.8A2.38 2.38 0 0 0 .67 5.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsNewsmall);
export default __webpack_public_path__ + "static/media/whatsNew.small.98e2de4793cb7295ddd1368578c6df37.svg";
export { ForwardRef as ReactComponent };